import AOS from "aos";
import "aos/dist/aos.css";
import ReactDOM from "react-dom/client";
// import "./styles/Unchurch.css";
//import { setPrefix } from "./lib/bandung/bandung";
import App from "./App";
import "./index.css";

//setPrefix("http://localhost:5000/http://www.dhorobha.com");
//setPrefix("http://localhost:5000/http://localhost:8080") ;

AOS.init();

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
